import React from 'react';

import { NewsSummaryPlayer } from './NewsSummaryPlayer';
import { NewsSummaryToggle } from './NewsSummaryToggle';

type NewsSummaryProps = {
  newsId: string | string[];
  summaryBody?: string[];
  thumbnailUrl?: string;
  isCheckedSummary: boolean;
  toggleSummary: () => void;
};

export const NewsSummary = (props: NewsSummaryProps) => {
  const { isCheckedSummary, summaryBody, thumbnailUrl, toggleSummary, newsId } = props;
  if (summaryBody?.length < 1) {
    return null;
  }

  return (
    <div className="summary">
      <div className="summaryHeader">
        <NewsSummaryPlayer />
        <p className="summaryTit">AI 뉴스 요약</p>
        <NewsSummaryToggle newsId={newsId} isCheckedToggle={isCheckedSummary} toggleSummary={toggleSummary} />
      </div>
      <SummaryList isSummaryChecked={isCheckedSummary} summaryBody={summaryBody} thumbnailUrl={thumbnailUrl} />
    </div>
  );
};
type NewsSummaryListProps = {
  isSummaryChecked: boolean;
  summaryBody?: string[];
  thumbnailUrl?: string;
};
const SummaryList = ({ isSummaryChecked, summaryBody, thumbnailUrl }: NewsSummaryListProps) => {
  if (!isSummaryChecked || summaryBody?.length < 1) {
    return null;
  }

  return (
    <>
      <ul className="summaryContents">
        {summaryBody?.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
      {!!thumbnailUrl && <img className="summaryThumbnail" src={thumbnailUrl} alt="뉴스 썸네일 이미지" />}
    </>
  );
};
